// Partners data - logos and alt text for partner organizations
export const partners = [
  { imageKey: "GDTraffic", alt: "General Directorate of Traffic" },
  { imageKey: "MOI", alt: "Ministry of Interior" },
  { imageKey: "CSB", alt: "Civil Service Bureau" },
  { imageKey: "MOW", alt: "Ministry of Works" },
  { imageKey: "Shura", alt: "Shura Council" },
  { imageKey: "CBB", alt: "Central Bank of Bahrain" },
  { imageKey: "GovHospitals", alt: "Government Hospitals" },
  { imageKey: "MOIC", alt: "Ministry of Industry and Commerce" },
  { imageKey: "IGA", alt: "Information & Government Authority" },
  { imageKey: "MUN", alt: "Ministry of Municipalities Affairs and Agriculture" },
  { imageKey: "SLRB", alt: "Survey and Land Registration Bureau" },
  { imageKey: "NAO", alt: "National Audit Office" },
  { imageKey: "BapcoR", alt: "Bapco Refinery" },
  { imageKey: "BapcoG", alt: "Bapco Gas" },
  { imageKey: "alba", alt: "Alba" },
  { imageKey: "asry", alt: "Asry" },
  { imageKey: "BAS", alt: "Bahrain Airport Service" },
  { imageKey: "YBAKanoo", alt: "Yusuf Bin Ahmed Kanoo" },
  { imageKey: "benefit", alt: "Benefit" },
  { imageKey: "Tamkeen", alt: "Tamkeen" },
  { imageKey: "edb", alt: "Economic Development Board" },
  { imageKey: "zain", alt: "Zain" },
];
